import React, { useEffect, useState } from "react";
import CustomModel from "../../Utility/CustomModel";

const Keywords = ({ handleCancel, show, editor }) => {
  const [keywords, setKeywords] = useState([]);

  useEffect(() => {
    if (!editor) return;

    const keywords = editor?.dom.select("kwd");

    const parsed = keywords.map((affElement, index) => {
      return {
        index,
        tag: affElement.tagName.toLowerCase(),
        value: affElement.innerHTML,
      };
    });

    setKeywords(parsed);
  }, [editor]);

  console.log(keywords);

  const handleChange = (i, value) => {
    setKeywords((prev) =>
      prev.map((item, index) =>
        i === index ? { ...item, value: value } : item
      )
    );
  };

  const handleAddRow = (i) => {
    const newItem = {
      index: keywords.length,
      tag: "kwd",
      value: "",
    };
    setKeywords((prev) => [
      ...prev.slice(0, i + 1),
      newItem,
      ...prev.slice(i + 1),
    ]);
  };

  const handleRemoveRow = (i) => {
    setKeywords((prev) => prev.filter((_, index) => index !== i));
  };

  const handleSubmit = () => {
    const parent = editor?.dom?.select("kwd-group")[0];

    if (!parent) {
      console.error("No kwd-group found in the editor");
      return;
    }

    // Clear existing <kwd> elements first
    editor.dom.select("kwd").forEach((el) => editor.dom.remove(el));

    // Append new/edited elements
    keywords.forEach((item) => {
      editor.dom.add(parent, item.tag, {}, item.value);
    });

    handleCancel(); // Close modal
  };

  return (
    <div className="w-fit h-fit">
      <CustomModel
        handleCancel={handleCancel}
        heading="Affiliation"
        width="50%"
        show={show}
      >
        <div className="flex flex-col">
          <div className="flex flex-col overflow-auto max-h-[500px]">
            {keywords?.map((data, i) => {
              return (
                <div key={i} className="grid grid-cols-2 gap-2 text-[13px] p-2">
                  <div key={i} className="flex flex-col gap-2 ">
                    <label>Keyword</label>
                    <input
                      title={data.value}
                      className="border-[1px] border-grey"
                      type="text"
                      value={data.value}
                      onChange={(e) => handleChange(i, e.target.value)}
                    />
                  </div>

                  <div className="flex justify-center items-center pt-4 mt-2 gap-2">
                    <button
                      className="px-4 border border-grey"
                      onClick={() => handleAddRow(i)}
                    >
                      Add Row
                    </button>
                    <button
                      className="px-4 border border-grey"
                      onClick={() => handleRemoveRow(i)}
                      disabled={keywords.length === 1}
                    >
                      Delete Row
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="ml-auto">
            <div className="flex py-3 gap-4">
              <button
                className="px-[15px] py-1 rounded-[8px] hover:text-[#20c77c] border border-grey hover:border-[#20c77c]"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="px-[15px] py-1 bg-[#00b96b] text-white rounded-[8px] hover:bg-hoverbtnbg"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </CustomModel>
    </div>
  );
};

export default Keywords;
